import React, { FC, memo, useState, useCallback } from 'react'
import { useReactiveVar } from '@apollo/client'

import { useNotifications } from 'modulesCommon/Notifications/services'
import { SideMenu } from 'modulesCommon/Header/components'
import { newNotificationVar } from 'modulesCommon/store'
import { NotificationSideMenu, NotificationSideMenuHeader } from 'modulesCommon/Notifications/components'
import { NOTIFICATION_TYPE_VIEW } from '../../Notifications/constants'
import { useHeaderNotificationsBell, useNotificationActions } from '../../Notifications/services'
import { TSelectedNotification } from '../../Notifications/types'
import { useDeleteNotification } from '../../Notifications/services/useDeleteNotifications'

export const NotificationDropDown: FC = memo(() => {
  const [notificationType, setNotificationType] = useState<NOTIFICATION_TYPE_VIEW>(NOTIFICATION_TYPE_VIEW.STORYBOX)
  const newNotification = useReactiveVar(newNotificationVar)

  const { getNotifications } = useNotifications(newNotification)
  const { isAnimatedBell } = useHeaderNotificationsBell(newNotification)
  const { onDeleteNotifications } = useDeleteNotification()
  const { onClickNotification } = useNotificationActions()

  const allNotifications = getNotifications()
  const notifications = getNotifications(notificationType)

  const onDeleteNotificationRow = useCallback((ids?: TSelectedNotification[]) => () => {
    if (ids) onDeleteNotifications(ids)
  } , [onDeleteNotifications])

  const onDeleteAllNotifications = useCallback(() => {
    onDeleteNotifications(allNotifications.reduce((acc: TSelectedNotification[], item) => [...acc, ...(item?.ids ?? [])], []))
  } , [onDeleteNotifications, allNotifications])

  return (
    <SideMenu isAnimatedBell={isAnimatedBell} quantity={allNotifications.length}>
      <>
        <NotificationSideMenuHeader
          typeView={notificationType}
          setTypeView={setNotificationType}
          hasNotifications={!!allNotifications.length}
          deleteNotifications={onDeleteAllNotifications}
        />
        <NotificationSideMenu
          notifications={notifications}
          onClickNotification={onClickNotification}
          onDeleteNotifications={onDeleteNotificationRow}
        />
      </>
    </SideMenu>
  )
})
